import Menu from "../../components/Menu/Menu"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { useTranslation } from "react-i18next"
import {
  faRotateLeft,
  faClock,
  faFileCircleCheck,
  faMoneyBillTransfer,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SEO } from "../../seo/Seo"
import { ContractDownloadsCard } from "../../components/ContractDownloads/ContractDownloadsCard"

export default function CancellationPolicy() {
  const { t } = useTranslation("cancellation")

  const sections = [
    {
      icon: faRotateLeft,
      title: t("cancel1_title"),
      content: [t("cancel1_description")],
    },
    {
      icon: faClock,
      title: t("cancel2_title"),
      content: [t("cancel2_description")],
    },
    {
      icon: faFileCircleCheck,
      title: t("cancel3_title"),
      content: [t("cancel3_description")],
    },
    {
      icon: faMoneyBillTransfer,
      title: t("cancel4_title"),
      content: [t("cancel4_description")],
    },
    {
      icon: faTriangleExclamation,
      title: t("cancel5_title"),
      content: [t("cancel5_description")],
    },
  ]

  return (
    <Animate type={AnimationTypes.fadeIn}>
      <div className="min-h-screen bg-white">
        <SEO
          title="Política de cancelamento do catalojei"
          description="Entenda as regras de cancelamento e arrependimento do catalojei, software para loja SaaS."
          path="/cancellation-policy"
        />

        <Menu />

        <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="space-y-8 mt-20">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white border-l-4 border-red-500 shadow-md rounded-lg p-6 transition hover:shadow-lg"
              >
                <div className="flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-orange-400 flex items-center justify-center text-white shadow-md">
                    <FontAwesomeIcon icon={section.icon} />
                  </div>

                  <div className="flex-1">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3">{section.title}</h2>

                    <div className="space-y-3">
                      {section.content.map((text, i) => (
                        <p key={i} className="text-sm sm:text-base text-gray-600 leading-relaxed">
                          {text}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <ContractDownloadsCard showAutomaticAcceptance />
          </div>
        </main>
      </div>
    </Animate>
  )
}
